import { AboutUniversityConst } from "./single-pages/AboutUniversity/about-university";
import { OurAdvantagesConst } from "./single-pages/AboutUniversity/our-advantages";
import { CampusConst } from "./single-pages/AboutUniversity/сampus";
////////////////////
import { AdmissionProcessDistanceLearningConst } from "./single-pages/AdmissionProcess/admisision-process-distance-learning";
import { AdmissionProcessFullTimeConst } from "./single-pages/AdmissionProcess/admission-process-full-time";
////////////////////
import { EducationPersonalConst } from "./single-pages/Education/education-personal";
import { EducationRemotelyConst } from "./single-pages/Education/education-remotely";
////////////////////
import { ModernPedagogicalTechnologiesConst } from "./single-pages/AdvancedTraining/modern-pedagogical-technologies";
import { DigitizationAndEdtechConst } from "./single-pages/AdvancedTraining/digitization-and-edtech";
import { InternationalCooperationAndInternationalizationConst } from "./single-pages/AdvancedTraining/international-cooperation-and-internationalization";
import { QualityAndAcademicIntegrityConst } from "./single-pages/AdvancedTraining/quality-and-academic-integrity";
import { MedicineAndHealthcareConst } from "./single-pages/AdvancedTraining/medicine-and-healthcare";
import { SoftSkillsAndResourcesOfTheTeachetConst } from "./single-pages/AdvancedTraining/soft-skills-and-resources-of-the-teachet";
import { EnglishForCareerAndInternationalCommunicationConst } from "./single-pages/AdvancedTraining/english-for-career-and-international-communication";
import { InnovationAndProjectThinkingInHigherEducationConst } from "./single-pages/AdvancedTraining/innovation-and-project-thinking-in-higher-education";
////////////////////
import { pharmacyConst } from "./single-pages/Programs/FacultyOfMedicine/pharmacy";
import { clinicalPsychologyConst } from "./single-pages/Programs/FacultyOfMedicine/clinicalPsychology";
import { nursingConst } from "./single-pages/Programs/FacultyOfMedicine/nursing";
import { fundamentalMedicineConst } from "./single-pages/Programs/FacultyOfMedicine/fundamentalMedicine";
import { medicalAndPreventiveCareConst } from "./single-pages/Programs/FacultyOfMedicine/medicalAndPreventiveCare";
import { pediatricsConst } from "./single-pages/Programs/FacultyOfMedicine/pediatrics";
import { medicalCareConst } from "./single-pages/Programs/FacultyOfMedicine/medicalCare";
import { dentistryConst } from "./single-pages/Programs/FacultyOfMedicine/dentistry";
import { traditionalMedicineConst } from "./single-pages/Programs/FacultyOfMedicine/traditionalMedicine";
import { medicalAndPedagogicalCareConst } from "./single-pages/Programs/FacultyOfMedicine/medicalAndPedagogicalCare";
import { obstetricsAndGynecologyConst } from "./single-pages/Programs/FacultyOfMedicine/obstetricsAndGynecology";
import { endocrinologyConst } from "./single-pages/Programs/FacultyOfMedicine/endocrinology";
import { therapyConst } from "./single-pages/Programs/FacultyOfMedicine/therapy";
import { otorhinolaryngologyConst } from "./single-pages/Programs/FacultyOfMedicine/otorhinolaryngology";
import { cardiologyConst } from "./single-pages/Programs/FacultyOfMedicine/cardiology";
import { ophthalmologyConst } from "./single-pages/Programs/FacultyOfMedicine/ophthalmology";
import { infectiousDiseasesConst } from "./single-pages/Programs/FacultyOfMedicine/infectiousDiseases";
import { dermatovenerologyConst } from "./single-pages/Programs/FacultyOfMedicine/dermatovenerology";
import { neurologyConst } from "./single-pages/Programs/FacultyOfMedicine/neurology";
import { generalOncologyConst } from "./single-pages/Programs/FacultyOfMedicine/generalOncology";
import { psychiatryConst } from "./single-pages/Programs/FacultyOfMedicine/psychiatry";
import { surgeryConst } from "./single-pages/Programs/FacultyOfMedicine/surgery";
import { instumentalAndFunctionalMethodsOfDiagnosticsConst } from "./single-pages/Programs/FacultyOfMedicine/instumentalAndFunctionalMethodsOfDiagnostics";
import { neurosurgeryConst } from "./single-pages/Programs/FacultyOfMedicine/neurosurgery";
import { healthcareManagementConst } from "./single-pages/Programs/FacultyOfMedicine/healthcareManagement";
import { medicalPshychologyConst } from "./single-pages/Programs/FacultyOfMedicine/medicalPshychology";
import { urologyConst } from "./single-pages/Programs/FacultyOfMedicine/urology";
import { morphologyConst } from "./single-pages/Programs/FacultyOfMedicine/morphology";
import { anesthesiologyAndResuscitationConst } from "./single-pages/Programs/FacultyOfMedicine/anesthesiologyAndResuscitation";
import { traumatologyAndOrthopedicsConst } from "./single-pages/Programs/FacultyOfMedicine/traumatologyAndOrthopedics";
import { familyMedicineConst } from "./single-pages/Programs/FacultyOfMedicine/familyMedicine";
import { forensicMedicalExaminationConst } from "./single-pages/Programs/FacultyOfMedicine/forensicMedicalExamination";
import { pathologicalAnatomyConst } from "./single-pages/Programs/FacultyOfMedicine/pathologicalAnatomy";
import { ambulanceConst } from "./single-pages/Programs/FacultyOfMedicine/ambulance";
import { pharmacologyConst } from "./single-pages/Programs/FacultyOfMedicine/pharmacology";
////////////////////
import { architecturalEnvironmentDesignConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/architecturalEnvironmentDesign";
import { automotiveTransportMaintenanceConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/automotiveTransportMaintenance";
import { buildingEngineeringAndMaintenanceConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/buildingEngineeringAndMaintenance";
import { civilEngineeringConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/civilEngineering";
import { energyAndWaterSupplyInConstructionConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/energyAndWaterSupplyInConstruction";
import { architectureAndUrbanPlanningConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/architectureAndUrbanPlanning";
import { architectureConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/architecture";
import { biomedicalEngineeringConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/biomedicalEngineering";
import { geodesyAndLandManagementConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/geodesyAndLandManagement";
import { railwayTransportConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/railwayTransport";
import { oilAndGasEngineeringConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/oilAndGasEngineering";
import { constructionProjectManagementConst } from "./single-pages/Programs/FacultyOfArchitectureAndEngineering/constructionProjectManagement";
////////////////////
import { internationalBusinessConst } from "./single-pages/Programs/FacultyOfBusiness/internationalBusiness";
import { financialManagementConst } from "./single-pages/Programs/FacultyOfBusiness/financialManagement";
import { entrepreneurshipConst } from "./single-pages/Programs/FacultyOfBusiness/entrepreneurship";
import { accountingAndAuditingConst } from "./single-pages/Programs/FacultyOfBusiness/accountingAndAuditing";
import { digitalMarketingConst } from "./single-pages/Programs/FacultyOfBusiness/digitalMarketing";
import { logisticsConst } from "./single-pages/Programs/FacultyOfBusiness/logistics";
import { bankingConst } from "./single-pages/Programs/FacultyOfBusiness/banking";
import { economicsOfEnterprisesAndOrganizationsConst } from "./single-pages/Programs/FacultyOfBusiness/economicsOfEnterprisesAndOrganizations";
////////////////////
import { programmingConst } from "./single-pages/Programs/FacultyOfIT/programming";
import { cybersecurityConst } from "./single-pages/Programs/FacultyOfIT/cybersecurity";
import { informationSystemsConst } from "./single-pages/Programs/FacultyOfIT/informationSystems";
import { artificialIntelligenceConst } from "./single-pages/Programs/FacultyOfIT/artificialIntelligence";
import { networkTechnologiesConst } from "./single-pages/Programs/FacultyOfIT/networkTechnologies";
import { digitalTransformationConst } from "./single-pages/Programs/FacultyOfIT/digitalTransformation";
import { gameAndMultimediaDevelopmentConst } from "./single-pages/Programs/FacultyOfIT/gameAndMultimediaDevelopment";
////////////////////
import { psychologyConst } from "./single-pages/Programs/FacultyOfSocialSciencesAndHumanities/psychology";
import { sociologyConst } from "./single-pages/Programs/FacultyOfSocialSciencesAndHumanities/sociology";
import { journalismConst } from "./single-pages/Programs/FacultyOfSocialSciencesAndHumanities/journalism";
import { linguisticsConst } from "./single-pages/Programs/FacultyOfSocialSciencesAndHumanities/linguistics";
import { pedagogyConst } from "./single-pages/Programs/FacultyOfSocialSciencesAndHumanities/pedagogy";
import { mediaAndDigitalCommunicationsConst } from "./single-pages/Programs/FacultyOfSocialSciencesAndHumanities/mediaAndDigitalCommunications";
import { internationalRelationsConst } from "./single-pages/Programs/FacultyOfSocialSciencesAndHumanities/internationalRelations";
////////////////////
import { civilLawConst } from "./single-pages/Programs/FacultyOfLaw/civilLaw";
import { criminalLawConst } from "./single-pages/Programs/FacultyOfLaw/criminalLaw";
import { internationalLawConst } from "./single-pages/Programs/FacultyOfLaw/internationalLaw";
import { corporateLawConst } from "./single-pages/Programs/FacultyOfLaw/corporateLaw";
import { laborLawConst } from "./single-pages/Programs/FacultyOfLaw/laborLaw";
import { environmentalLawConst } from "./single-pages/Programs/FacultyOfLaw/environmentalLaw";
import { lawInTheDigitalEconomyConst } from "./single-pages/Programs/FacultyOfLaw/lawInTheDigitalEconomy";

export const singlePagesConst = [
  AboutUniversityConst,
  OurAdvantagesConst,
  CampusConst,
  AdmissionProcessFullTimeConst,
  AdmissionProcessDistanceLearningConst,
  EducationPersonalConst,
  EducationRemotelyConst,
  ModernPedagogicalTechnologiesConst,
  DigitizationAndEdtechConst,
  InternationalCooperationAndInternationalizationConst,
  QualityAndAcademicIntegrityConst,
  MedicineAndHealthcareConst,
  SoftSkillsAndResourcesOfTheTeachetConst,
  EnglishForCareerAndInternationalCommunicationConst,
  InnovationAndProjectThinkingInHigherEducationConst,
  pharmacyConst,
  clinicalPsychologyConst,
  nursingConst,
  fundamentalMedicineConst,
  medicalAndPreventiveCareConst,
  pediatricsConst,
  medicalCareConst,
  dentistryConst,
  traditionalMedicineConst,
  medicalAndPedagogicalCareConst,
  obstetricsAndGynecologyConst,
  endocrinologyConst,
  therapyConst,
  otorhinolaryngologyConst,
  cardiologyConst,
  ophthalmologyConst,
  infectiousDiseasesConst,
  dermatovenerologyConst,
  neurologyConst,
  generalOncologyConst,
  psychiatryConst,
  surgeryConst,
  instumentalAndFunctionalMethodsOfDiagnosticsConst,
  neurosurgeryConst,
  healthcareManagementConst,
  medicalPshychologyConst,
  urologyConst,
  morphologyConst,
  anesthesiologyAndResuscitationConst,
  traumatologyAndOrthopedicsConst,
  familyMedicineConst,
  forensicMedicalExaminationConst,
  pathologicalAnatomyConst,
  ambulanceConst,
  pharmacologyConst,
  architecturalEnvironmentDesignConst,
  automotiveTransportMaintenanceConst,
  buildingEngineeringAndMaintenanceConst,
  civilEngineeringConst,
  energyAndWaterSupplyInConstructionConst,
  architectureAndUrbanPlanningConst,
  architectureConst,
  biomedicalEngineeringConst,
  geodesyAndLandManagementConst,
  railwayTransportConst,
  oilAndGasEngineeringConst,
  constructionProjectManagementConst,
  internationalBusinessConst,
  financialManagementConst,
  entrepreneurshipConst,
  accountingAndAuditingConst,
  digitalMarketingConst,
  logisticsConst,
  bankingConst,
  economicsOfEnterprisesAndOrganizationsConst,
  programmingConst,
  cybersecurityConst,
  informationSystemsConst,
  artificialIntelligenceConst,
  networkTechnologiesConst,
  digitalTransformationConst,
  gameAndMultimediaDevelopmentConst,
  psychologyConst,
  sociologyConst,
  journalismConst,
  linguisticsConst,
  pedagogyConst,
  mediaAndDigitalCommunicationsConst,
  internationalRelationsConst,
  civilLawConst,
  criminalLawConst,
  internationalLawConst,
  corporateLawConst,
  laborLawConst,
  environmentalLawConst,
  lawInTheDigitalEconomyConst,
];
